import React from 'react';
import { OPERATION_TYPE } from '../../util/varibles/constants';
import { TOperation2 } from '../../util/varibles/interface';
import Icon, { ICON_NAME } from '../Icon';

interface IProps {
    operation: TOperation2
}

const InvoiceCount: React.FC<IProps> = ({ operation }) => {
    const eventCount = (operation.invoices || []).filter(
        invoice => invoice.operation_type === OPERATION_TYPE.EVENT
    ).length;

    if (eventCount === 0)
        return null;

    return <div className='flex items-center gap-[2px]'>
        <Icon icon={ICON_NAME.MULTIPLE_INVOICE} size={19} />
        <span>{eventCount}</span>
    </div>;
};

export default InvoiceCount;
